<template>
	<div class="d-flex j-center">
		<div class="content-box">
			<div @click="$router.back()" class="d-flex a-center" style="cursor: pointer;">
				<div style="width: 13px;height: 13px;display: flex;align-items: center;">
					<img style="width: 13px;height: 13px;transform: rotate(180deg);" src="../../assets/brand_fixtures/jiantou (4).png" />
				</div>
				<div style="font-size: 16px;color: #4a86ff;margin-left: 6px;">返回默认服务</div>
			</div>
			<div class="d-flex" style="margin-top: 22px;">
				<div style="width: 300px;height: 600px;">
					<img style="width: 300px;height: 600px;" src="../../assets/brand_fixtures/zhuanyeban.png" />
				</div>
				<div style="margin-left: 100px;flex: 1;">
					<div class="d-flex a-center">
						<img style="width: 27px;height: 18px;" src="../../assets/brand_fixtures/biaoqian.png" />
						<div style="font-size: 16px;font-weight: 600;margin-left: 6px;display: flex;align-items: center;">
							企业专业版
							<el-button v-if="user_info.co_ver_show!=1" @click="co_version_switch(1)" style="margin-left: 24px;background: #1E69FF;" size="mini" type="primary">设为企业展示
							</el-button>
							<el-button v-else style="margin-left: 24px;background: #1E69FF;" size="mini" type="primary">当前企业展示
							</el-button>
						</div>
					</div>
					<div style="font-size: 16px;font-weight: 600;margin-top: 39px;">功能说明：</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						1.开通商协会特定首页享受进阶版首页样式，首页模块自定义编辑
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						2.开通商协会特定首页增加商协会动态发布，动态消息推送等功能
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						3.服务开通期间可直接体验平台后续新增功能服务等
					</div>
					
					<div style="font-size: 16px;font-weight: 600;margin-top: 80px;">开通说明：</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						1.开通商协会特定首页为2580元，期间免费享受平台现有和更新功能服务
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						2.到期未续费特定版首页自动取消展示样式，为您自动转换默认版。
					</div>
					<div style="font-size: 28px;font-weight: 600;margin-top: 39px;" class="d-flex a-center">
						<div>2580.00元</div>
						<div v-if="user_info.co_pe == 1" style="margin-left: auto;font-size: 16px;">
							{{$getDate(user_info.co_pe_end_time)}}到期
						</div>
					</div>
					<div class="d-flex">
						<div @click="$router.push('pay_index')" style="width: 150px;height: 36px;background: #1E69FF;border-radius: 4px;
						margin-top: 31px;color: #FFFFFF;font-size: 16px;cursor: pointer;" 
						class="d-flex a-center j-center">
							{{user_info.co_pe == 1 ?'续费':'开通'}}
						</div>
						
						<div v-if="user_info.co_pe == 1"
						@click="$router.push('add_banner')" style="margin-left: auto;width: 150px;height: 36px;background: #1E69FF;border-radius: 4px;
						margin-top: 31px;color: #FFFFFF;font-size: 16px;cursor: pointer;" 
						class="d-flex a-center j-center">
							编辑首页模块
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex" style="margin-top: 52px;">
				<div style="width: 300px;height: 600px;">
					<img style="width: 300px;height: 600px;" src="../../assets/brand_fixtures/gexingban.png" />
				</div>
				<div style="margin-left: 100px;flex: 1;">
					<div class="d-flex a-center">
						<img style="width: 27px;height: 18px;" src="../../assets/brand_fixtures/biaoqian.png" />
						<div style="font-size: 16px;font-weight: 600;margin-left: 6px;display: flex;align-items: center;">
							企业个性版
							<el-button v-if="user_info.co_ver_show!=2" @click="co_version_switch(2)" style="margin-left: 24px;background: #1E69FF;" size="mini" type="primary">设为企业展示
							</el-button>
							<el-button v-else style="margin-left: 24px;background: #1E69FF;" size="mini" type="primary">当前企业展示
							</el-button>
						</div>
					</div>
					
					<div style="font-size: 16px;font-weight: 600;margin-top: 39px;">功能说明：</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						1.开通商协会特定首页享受进阶版首页样式，首页模块自定义编辑
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						2.开通商协会特定首页增加商协会动态发布，动态消息推送等功能
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						3.服务开通期间可直接体验平台后续新增功能服务等
					</div>
					
					<div style="font-size: 16px;font-weight: 600;margin-top: 80px;">开通说明：</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						1.开通商协会特定首页为2580元，期间免费享受平台现有和更新功能服务
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						2.到期未续费特定版首页自动取消展示样式，为您自动转换默认版。
					</div>
					<div style="font-size: 28px;font-weight: 600;margin-top: 39px;" class="d-flex a-center">
						<div>2580.00元</div>
						<div v-if="user_info.co_gpe == 1" style="margin-left: auto;font-size: 16px;">
							{{$getDate(user_info.co_gpe_end_time)}}到期
						</div>
					</div>
					<div class="d-flex">
						<div @click="$router.push('pay_index_ge')" style="width: 150px;height: 36px;background: #1E69FF;border-radius: 4px;
						margin-top: 31px;color: #FFFFFF;font-size: 16px;cursor: pointer;" 
						class="d-flex a-center j-center">
							{{user_info.co_gpe == 1 ?'续费':'开通'}}
						</div>
						
						<div v-if="user_info.co_gpe == 1"
						@click="$router.push('ind_decoration')" style="margin-left: auto;width: 150px;height: 36px;background: #1E69FF;border-radius: 4px;
						margin-top: 31px;color: #FFFFFF;font-size: 16px;cursor: pointer;" 
						class="d-flex a-center j-center">
							编辑首页模块
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex" style="margin-top: 52px;">
				<div style="width: 300px;height: 600px;">
					<img style="width: 300px;height: 600px;" src="../../assets/brand_fixtures/gexingban.png" />
				</div>
				<div style="margin-left: 100px;flex: 1;">
					<div class="d-flex a-center">
						<img style="width: 27px;height: 18px;" src="../../assets/brand_fixtures/biaoqian.png" />
						<div style="font-size: 16px;font-weight: 600;margin-left: 6px;display: flex;align-items: center;">
							智享版
							<el-button v-if="user_info.co_ver_show!=3" @click="co_version_switch(3)" style="margin-left: 24px;background: #1E69FF;" size="mini" type="primary">设为企业展示
							</el-button>
							<el-button v-else style="margin-left: 24px;background: #1E69FF;" size="mini" type="primary">当前企业展示
							</el-button>
						</div>
					</div>
					<div style="font-size: 16px;font-weight: 600;margin-top: 39px;">功能说明：</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						1.开通商协会特定首页享受进阶版首页样式，首页模块自定义编辑
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						2.开通商协会特定首页增加商协会动态发布，动态消息推送等功能
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						3.服务开通期间可直接体验平台后续新增功能服务等
					</div>
					<div style="font-size: 16px;font-weight: 600;margin-top: 80px;">开通说明：</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						1.开通商协会特定首页为2580元，期间免费享受平台现有和更新功能服务
					</div>
					<div style="font-size: 14px;margin-top: 17px;color:#888888;">
						2.到期未续费特定版首页自动取消展示样式，为您自动转换默认版。
					</div>
					<div style="font-size: 28px;font-weight: 600;margin-top: 39px;" class="d-flex a-center">
						<div>2580.00元</div>
						<div v-if="user_info.co_zxb == 1" style="margin-left: auto;font-size: 16px;">
							{{$getDate(user_info.co_zxb_end_time)}}到期
						</div>
					</div>
					<div class="d-flex">
						<div @click="$router.push({path:'pay_index_ge',query:{state:3}})" style="width: 150px;height: 36px;background: #1E69FF;border-radius: 4px;
						margin-top: 31px;color: #FFFFFF;font-size: 16px;cursor: pointer;" 
						class="d-flex a-center j-center">
							{{user_info.co_zxb == 1 ?'续费':'开通'}}
						</div>
						<div v-if="user_info.co_zxb == 1"
						@click="$router.push('smart_edition')" style="margin-left: auto;width: 150px;height: 36px;background: #1E69FF;border-radius: 4px;
						margin-top: 31px;color: #FFFFFF;font-size: 16px;cursor: pointer;" 
						class="d-flex a-center j-center">
							编辑首页模块
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				user_info:''
			}
		},
		created() {
			this.get_company_info()
		},
		methods:{
			get_company_info(){
				let params = {
					act:'get_company_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
				}
				this.$api.get_company_info(params).then((res)=>{
					this.user_info = res.data
					console.log(this.user_info);
				})
			},
			co_version_switch(co_ver_show){
				let params = {
					act:'co_version_switch',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					co_ver_show: co_ver_show
				}
				this.$api.get_company_info(params).then((res)=>{
					if(res.code==0){
						this.user_info.co_ver_show=co_ver_show
						this.$message({
							showClose: false,
							message: '设置成功',
							type: 'success',
							offset: 350
						})
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'success',
							offset: 350
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.content-box{
		width: 1170px;
		min-height: 960px;
		background: #FFFFFF;
		border-radius: 6px;
		flex-wrap: wrap;
		padding: 30px 127px;
		box-sizing: border-box;
	}
</style>